import { PartnerHospitalDoctorPositionCode } from "@/entities/hospital/api/types"

const DOCTOR_POSITION_LABEL: Record<PartnerHospitalDoctorPositionCode, string> = {
  [PartnerHospitalDoctorPositionCode.CHIEF_DIRECTOR]: "대표 원장",
  [PartnerHospitalDoctorPositionCode.DIRECTOR]: "원장",
  [PartnerHospitalDoctorPositionCode.DOCTOR]: "",
}

export function getDoctorPositionLabel(code?: PartnerHospitalDoctorPositionCode | null) {
  if (!code) return ""
  return DOCTOR_POSITION_LABEL[code] ?? ""
}

